// const path = require('path');
const adapter = require('webrtc-adapter');
adapter.disableLog(false)
// Shimming
if(adapter.browserShim){
  adapter.browserShim.shimGetUserMedia(window);
}else{
  console.warn('[SwitchRTC_SDK]', 'This browser is not supported by adapter.js');
}

const switchrtc = require('./Modules/switchrtc_core');


global.switchrtc = switchrtc;
global.adapter = adapter;



// WEBPACK FOOTER //
// ./src/switchrtc.js